var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgConfettiColorful = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2289 78.1399L22.6566 36.5664L19.1084 46.9266L53.8698 81.6881L64.2289 78.1399Z",
    fill: "#0479F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91504 88.3641L12.4307 95.8798L22.7909 92.3328L8.46323 78.0039L4.91504 88.3641Z",
    fill: "#0479F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5597 57.2852L12.0127 67.6454L33.1512 88.784L43.5103 85.2346L15.5597 57.2852Z",
    fill: "#0479F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8704 81.6884L19.1078 46.9258L15.5596 57.286L43.5102 85.2354L53.8704 81.6884Z",
    fill: "#EDCBBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46387 78.0036L22.7916 92.3325L33.1506 88.7831L12.0121 67.6445L8.46387 78.0036Z",
    fill: "#EDCBBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 99.7958L12.4313 95.8801L4.91566 88.3633L1 99.7958Z",
    fill: "#0479F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6914 25.1875L32.0601 30.8176L38.4396 31.0803L35.0709 25.4502L28.6914 25.1875Z",
    fill: "#0084F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9126 18.1659L66.1018 14.1514L65.6042 7.78516L60.415 11.7996L60.9126 18.1659Z",
    fill: "#0084F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.082 57.2304H67.6423L71.1447 51.8906H64.5832L61.082 57.2304Z",
    fill: "#0084F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3457 39.7162L77.3385 42.3885L82.7108 38.9367L76.7192 36.2656L71.3457 39.7162Z",
    fill: "#0084F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0227 47.691C61.0227 48.8513 60.083 49.7923 58.9215 49.7923C57.7613 49.7923 56.8203 48.8513 56.8203 47.691C56.8203 46.5296 57.7613 45.5898 58.9215 45.5898C60.083 45.5898 61.0227 46.5296 61.0227 47.691Z",
    fill: "#EDCBBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3958 30.234C64.3958 31.3943 63.4548 32.3352 62.2946 32.3352C61.1343 32.3352 60.1934 31.3943 60.1934 30.234C60.1934 29.0738 61.1343 28.1328 62.2946 28.1328C63.4548 28.1328 64.3958 29.0738 64.3958 30.234Z",
    fill: "#EDCBBE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8821 28.1325C96.8821 29.2927 95.9423 30.2337 94.7809 30.2337C93.6207 30.2337 92.6797 29.2927 92.6797 28.1325C92.6797 26.9722 93.6207 26.0312 94.7809 26.0312C95.9423 26.0312 96.8821 26.9722 96.8821 28.1325Z",
    fill: "#EDCBBE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1204 73.7262C77.1204 74.8864 76.1806 75.8274 75.0192 75.8274C73.8589 75.8274 72.918 74.8864 72.918 73.7262C72.918 72.5648 73.8589 71.625 75.0192 71.625C76.1806 71.625 77.1204 72.5648 77.1204 73.7262Z",
    fill: "#EDCBBE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0374 51.8942C98.0374 53.0544 97.0976 53.9954 95.9362 53.9954C94.7759 53.9954 93.835 53.0544 93.835 51.8942C93.835 50.7327 94.7759 49.793 95.9362 49.793C97.0976 49.793 98.0374 50.7327 98.0374 51.8942Z",
    fill: "#EDCBBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5657 12.9762C33.5657 14.1377 32.6247 15.0774 31.4645 15.0774C30.303 15.0774 29.3633 14.1377 29.3633 12.9762C29.3633 11.816 30.303 10.875 31.4645 10.875C32.6247 10.875 33.5657 11.816 33.5657 12.9762Z",
    fill: "#EDCBBE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6751 49.7926C48.6751 50.9529 47.7341 51.8938 46.5739 51.8938C45.4136 51.8938 44.4727 50.9529 44.4727 49.7926C44.4727 48.6312 45.4136 47.6914 46.5739 47.6914C47.7341 47.6914 48.6751 48.6312 48.6751 49.7926Z",
    fill: "#EDCBBE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7017 42.3107C38.2246 42.3107 37.774 42.0263 37.5836 41.5577C37.3354 40.9408 37.633 40.2384 38.2487 39.989C38.8005 39.7649 51.7174 34.3565 47.0415 22.0384C41.5788 7.64442 51.327 1.82996 51.427 1.77333C52.0029 1.44321 52.7403 1.6396 53.0728 2.21671C53.4041 2.79261 53.2053 3.52996 52.6294 3.86249C52.3029 4.05406 44.5836 8.77092 49.2933 21.1842C54.8113 35.7203 39.3077 42.1601 39.1511 42.2239C39.0029 42.283 38.8511 42.3107 38.7017 42.3107Z",
    fill: "#0479F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_507_29338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 59,
    width: 44,
    height: 11
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.499 59.5195H99.2421V69.3398H56.499V59.5195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_507_29338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0392 69.3398C97.6633 69.3398 97.291 69.1639 97.056 68.8338C96.709 68.3494 88.4609 57.035 77.5572 64.4386C64.8235 73.0892 56.9054 64.9506 56.8271 64.8663C56.3705 64.3832 56.3934 63.6205 56.8777 63.1639C57.3597 62.7061 58.1247 62.7302 58.5801 63.2145C58.844 63.488 65.2247 69.9012 76.2042 62.4446C89.0645 53.7121 98.9223 67.3012 99.0199 67.4398C99.4054 67.982 99.2765 68.7326 98.7356 69.1169C98.5235 69.2675 98.2801 69.3398 98.0392 69.3398Z",
    fill: "#0479F7"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConfettiColorful, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/confettiColorful.7a8fa2d4.svg";
export { ForwardRef as ReactComponent };